export default "__VITE_ASSET__D0cWy3Yj__"